import React from 'react';

import Cube3Button from './Cube3Button';
import { makeStyles, createStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rounded: {
      padding: theme.customSpacing.padding[4],
      paddingTop: theme.customSpacing.padding[4],
      paddingBottom: theme.customSpacing.padding[4],
      borderRadius: theme.surfaceCorners.circular,
      height: 'auto'
    }
  }));

const RoundedButtonBase = ({ ...props }) => {
  
  const classes = useStyles()

  return (
  <Cube3Button
    colorVariant="ghost2"
    {...props}
    className={
      props.className
        ? `${props.className} ${classes.rounded}`
        : classes.rounded
    }
  />
)};

export const RoundedButton = RoundedButtonBase;
export default RoundedButton;
